// 加密知識＋
import Link from "next/link";

const NewsKnowledge = ({ t, knowList }) => {
  return (
    <div
      className="my-[20px] px-[25px] py-[20px] rounded-[2px] border-1 border-dashed
  border-black2 "
    >
      <h4 className="text-h4 text-black pb-[22px]">{t("KNOWLEDGE")}</h4>

      {knowList?.map((know, i) => (
        <div
          key={know?.title + i}
          className="py-[22px] block border-t-1 border-dashed border-black2"
        >
          {/* 標題 */}
          <h5 className="text-bd2b text-pale9">
            {know?.vocabulary} {know?.title && ` - ${know?.title}`}
          </h5>
          {/* 內容 */}

          <div
            className="mt-[10px] mb-[22px] text-bd1m text-black9 line-clamp-2"
            dangerouslySetInnerHTML={{ __html: know?.brief }}
            suppressHydrationWarning
          />

          {/* 知識庫 連結 */}
          {/* TODO 暫時隱藏 */}
          {/* <Link
            href={`/knowledge-base/${know?.vocabulary}`}
            target="_blank"
            rel="noopener"
            className="inline-block rounded-[2px] text-btn1 text-black border-1 border-black2 
            trans px-[12px] py-[7px] hover:bg-black hover:text-white
            hover:border-black"
          >
            ＋ READ MORE
          </Link> */}
        </div>
      ))}
    </div>
  );
};

export default NewsKnowledge;
